<template>
<div class="chapter">
<div class="inner_page">
<p class="part-num" id="P1">PART I</p>
<p class="part-title">T<span class="small">HE</span> H<span class="small">ISTORY OF THE</span> K<span class="small">ANCAMAGUS</span> R<span class="small">OUTE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?7dd81cb7